import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  createArn_api,
  get_arnInitialData,
  get_arnTokenValid,
} from "./adminArnsAPI";

const initialState = {
  loading: false,
  arn_details: {},
  arn_token_details: {},
  arn_token_loading: false,
  create_arn_loading: false,
};
const actions = {
  GETARNINITIALDATA: "getAdminArns/GETARNINITIALDATA",
  GETARNTOKENVALID: "getArnTokenValid/GETARNTOKENVALID",
  CREATEARNS: "createArn/CREATEARNS",
};

export const getAdminArns = createAsyncThunk(
  actions.GETARNINITIALDATA,
  async (payload) => {
    const response = await get_arnInitialData(payload);
    return response;
  }
);
export const getArnTokenValid = createAsyncThunk(
  actions.GETARNTOKENVALID,
  async (payload) => {
    const response = await get_arnTokenValid(payload);
    return response;
  }
);
export const createArn = createAsyncThunk(
  actions.CREATEARNS,
  async (payload) => {
    const response = await createArn_api(payload);
    return response;
  }
);
export const adminArnsSlice = createSlice({
  name: "adminArns",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminArns.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAdminArns.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.loading = false;
        state.arn_details = data;
        if (success) {
          /* message.success(msg); */
        } else {
          message.error(msg);
        }
      })
      .addCase(getAdminArns.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });
    builder
      .addCase(getArnTokenValid.pending, (state) => {
        state.arn_token_loading = true;
      })
      .addCase(getArnTokenValid.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.arn_token_loading = false;
        state.arn_details = data;
        if (success) {
          /* message.success(msg); */
        } else {
          message.error(msg);
        }
      })
      .addCase(getArnTokenValid.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.arn_token_loading = false;
        message.error(msg);
      });
    builder
      .addCase(createArn.pending, (state) => {
        state.create_arn_loading = true;
      })
      .addCase(createArn.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.create_arn_loading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(createArn.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.create_arn_loading = false;
        message.error(msg);
      });
  },
});
export const adminArnsActions = adminArnsSlice.actions;
export const { resetadminArnsDetails } = adminArnsSlice.actions;

export default adminArnsSlice.reducer;
